import { DFVE, DocumentoCreateParams } from '../../../../models';
import { actionsBeforeDocCreate } from '../../../../utils/helpers/actionsBeforeDocCreate';
import { apiClient } from '../../../../helpers';
import { AxiosResponse } from 'axios';
import { handleError, URL_GESTIFY_DOCUMENTI } from '../../../../utils';
import { getGestifyTokenCookies } from '../../../../helpers/authCookies';

export const gestifyCreateDfveDocumento = async (
  parameters: DocumentoCreateParams,
) => {
  try {
    const token = getGestifyTokenCookies().gestifyToken;
    const params = actionsBeforeDocCreate(parameters);
    const crea_riga_vuota =
      params['id'] || params['ignore_new_row'] ? undefined : false;
    delete params['ignore_new_row'];
    const response = await apiClient.post<AxiosResponse>({
      url: `${URL_GESTIFY_DOCUMENTI}/${DFVE}`,
      params: {
        ...params,
        crea_riga_vuota,
        token,
      },
    });
    console.log('gestifyCreateDfveDocumento', response);
    if (response.status >= 200 || response.status < 300) {
      return { data: response.data, params };
    }

    return handleError(response.status, response.data?.status);
  } catch (error: any) {
    return handleError(
      error?.response?.status ?? error?.message,
      error?.response?.data,
    );
  }
};
